export default "__VITE_ASSET__Bli5eQ$R__"